import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from 'assets/esp-kobudo-logo.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4350cc33"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mobile-h2 ellipsis"
}

import { ref, computed } from 'vue';
import { QBtn } from 'quasar';

// STORES
import { useUiStore } from 'src/stores/ui';

// Personal components
import QLayoutHeaderMenu from '@layouts/components/QLayoutHeaderMenu.vue';
import DialogAuthenticate from '@components/dialog/DialogAuthenticate.vue';
import DialogForgottenPass from '@components/dialog/DialogForgottenPass.vue';
import DialogSignup from '@components/dialog/DialogSignup.vue';
import DiagGeneric from '@components/dialog/DiagGeneric.vue';

// ViewModel
import { useGlobalVM } from '@viewmodel/global.vm';

// Personal lib
import bus from '../../shared/lib/eventbus.lib';
import { fullReload } from '../../shared/lib/browser.lib';
import { BusEventEnum } from 'src/shared/enum/bus/bus-events.enum';
import { $t } from 'src/i18n/utils';
import { IConfig } from '@shared/interface/config.interface';
import { closeAllModals, loggoutActions, redirectOnLoggout } from '@shared/lib/loggout.lib';
import { IUser } from '@shared/interface/model.interface';
import { sessionManager } from '@shared/service/sessionManager/session-manager.class';

/**
 * Viewmodel
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutHeader',
  setup(__props) {

// Vendor
const { isMobile } = useGlobalVM();

/**
 * Elements
 */
const qBtnConnexion = ref<QBtn>();

/**
 * Stores
 */
const uiStore = useUiStore();

/**
 * Reactive data
 */
const showAuthDialog = ref<boolean>(false);
const showSignupDialog = ref<boolean>(false);
const showForgottenPassDialog = ref<boolean>(false);
const showLoggoutConfirmDialog = ref<boolean>(false);
const logoutLoading = ref<boolean>(false)

/**
 * Computed properties
 */
const config = computed<IConfig | undefined>(() => uiStore.config);
const pageTitle = computed<string | undefined>(() => uiStore.pageTitle);
const isOnline = computed<boolean>(() => sessionManager.isOnline.value === true);
const connectedUser = computed<IUser | undefined>(
  () => sessionManager.currentUser.value,
);

/**
 * Methods
 */
function clickMenuButton() {
  bus.emit(BusEventEnum.LEFT_PANEL_TOGGLE);
}

function doLogin() {
  showAuthDialog.value = true;
}

function showLogout() {
  showLoggoutConfirmDialog.value = true;
}

async function doLogout(params?: any) {
  logoutLoading.value = true
  await loggoutActions({ showLoggoutNotif: true })
    .then(() => closeAllModals())
    .then(() => redirectOnLoggout())
  logoutLoading.value = false
  showLoggoutConfirmDialog.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_header, {
      elevated: "",
      class: "bg-primary text-white focus-dashed",
      role: "banner",
      "height-hint": "58"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_toolbar, null, {
          default: _withCtx(() => [
            _createCommentVNode(" Menu button "),
            _createVNode(_unref(QBtn), {
              dense: "",
              flat: "",
              round: "",
              icon: "menu",
              class: "set-outline set-outline-secondary",
              title: "Navigation principale",
              onClick: clickMenuButton
            }),
            _createCommentVNode(" Grands écrans (dont desktop) "),
            (!_unref(isMobile))
              ? (_openBlock(), _createBlock(_component_q_toolbar_title, { key: 0 }, {
                  default: _withCtx(() => [
                    _createCommentVNode(" Logo site "),
                    _createVNode(_component_q_avatar, { square: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_img, {
                          src: _imports_0,
                          style: {"max-width":"30px","height":"30px"},
                          fit: "fill"
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createTextVNode(" ESP Kobudo ")
                  ]),
                  _: 1 /* STABLE */
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createCommentVNode(" Petits écrans (dont mobiles) "),
                  _createVNode(_component_q_toolbar_title, null, {
                    default: _withCtx(() => [
                      (pageTitle.value)
                        ? (_openBlock(), _createElementBlock("h2", _hoisted_1, _toDisplayString(pageTitle.value), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                  })
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
            _createCommentVNode(" Refresh button "),
            (isOnline.value && _unref(isMobile))
              ? (_openBlock(), _createBlock(_unref(QBtn), {
                  key: 2,
                  flat: "",
                  round: _unref(isMobile),
                  icon: "refresh",
                  label: !_unref(isMobile) ? _unref($t)('layoutHeader.refreshBtn.label') : undefined,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(fullReload)())),
                  class: _normalizeClass(['set-outline', _unref(isMobile) ? 'q-ma-none' : '']),
                  title: _unref(isMobile) ? _unref($t)('layoutHeader.refreshBtn.label') : undefined
                }, null, 8 /* PROPS */, ["round", "label", "class", "title"]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Login / logout button "),
            _createVNode(_unref(QBtn), {
              ref_key: "qBtnConnexion",
              ref: qBtnConnexion,
              flat: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (connectedUser.value != null ? showLogout() : doLogin())),
              round: _unref(isMobile),
              icon: connectedUser.value != null ? 'logout' : 'login',
              class: _normalizeClass(['set-outline', _unref(isMobile) ? 'q-ma-none' : 'q-mr-sm']),
              label: 
          !_unref(isMobile)
            ? connectedUser.value != null
              ? _unref($t)('layoutHeader.logoutBtn.label')
              : _unref($t)('layoutHeader.loginBtn.label')
            : undefined
        
            }, null, 8 /* PROPS */, ["round", "icon", "class", "label"]),
            _createCommentVNode(" More button "),
            _createVNode(_unref(QBtn), {
              size: "12px",
              flat: "",
              dense: "",
              round: "",
              icon: "more_vert",
              onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
              class: "set-outline",
              title: "Afficher le menu contextuel"
            }, {
              default: _withCtx(() => [
                _createVNode(QLayoutHeaderMenu)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" Dialog : authenticate "),
    _createVNode(DialogAuthenticate, {
      show: showAuthDialog.value,
      "security-rules": config.value?.security,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (showAuthDialog.value = false)),
      onShowForgottenPass: _cache[4] || (_cache[4] = ($event: any) => (showForgottenPassDialog.value = true)),
      onShowSignup: _cache[5] || (_cache[5] = ($event: any) => (showSignupDialog.value = true))
    }, null, 8 /* PROPS */, ["show", "security-rules"]),
    _createCommentVNode(" Dialog : signup "),
    _createVNode(DialogSignup, {
      show: showSignupDialog.value,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (showSignupDialog.value = false))
    }, null, 8 /* PROPS */, ["show"]),
    _createCommentVNode(" Dialog : forgotten pass "),
    _createVNode(DialogForgottenPass, {
      show: showForgottenPassDialog.value,
      onClose: _cache[7] || (_cache[7] = ($event: any) => (showForgottenPassDialog.value = false))
    }, null, 8 /* PROPS */, ["show"]),
    _createCommentVNode(" Dialog : logout confirmation "),
    _createVNode(DiagGeneric, {
      show: showLoggoutConfirmDialog.value,
      title: "Déconnexion",
      message: "Confirmez-vous la déconnexion ?",
      "manage-loading": true,
      ok: { label: 'Se déconnecter', asyncHandler: doLogout },
      cancel: { label: 'Rester connecté' },
      onClose: _cache[8] || (_cache[8] = ($event: any) => (showLoggoutConfirmDialog.value = false)),
      onCancel: _cache[9] || (_cache[9] = ($event: any) => (showLoggoutConfirmDialog.value = false))
    }, null, 8 /* PROPS */, ["show", "ok"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})